import React from "react";
import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import { Flex, Text } from "../../../styles/utility-components";

type Props = {
  open: boolean;
  criteriaTitle: string;
  onOpenChange: (open: boolean) => void;
  deleteQuestion: () => void;
};

export function DeleteCriteriaModal({ open, onOpenChange, criteriaTitle, deleteQuestion }: Props) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} showCloseButton={false}>
      <Content gap={16} flexDirection="column">
        <Text h3>About to delete custom criteria</Text>
        <Flex gap={8} flexDirection="column">
          <Text>
            Are you sure you want to delete this custom criteria? <Text bold>{criteriaTitle}</Text>
          </Text>
          <Text>
            This criteria will not be shown on any new reports or on existing reports if you
            recreate them.
          </Text>
          <Text>This action cannot be undone.</Text>
        </Flex>
        <Flex gap={8} justifyContent="flex-end">
          <Button onClick={() => onOpenChange(false)} buttonType="secondary">
            Keep criteria
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => {
              deleteQuestion();
              onOpenChange(false);
            }}
          >
            Delete criteria
          </Button>
        </Flex>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  width: 440,
  gap: 16,
  flexDirection: "column",
  padding: 16,
});
